<template>
    <nav class="navbar navbar-expand-lg navbar-dark sticky-top">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">Mardoquéiro Dimbu</a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
        <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link" href="#landing" active-class="active-link">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#about" active-class="active-link">About</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#education" active-class="active-link">Education.&.Experiences</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#project" active-class="active-link">Project</a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" href="#testimonial">Testimonial</a>
            </li> -->
            <li class="nav-item">
              <a class="nav-link" href="#reachMe" active-class="active-link">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </template>

<style scoped>
.navbar-nav {
  display: flex;
  justify-content: flex-start;
  width: 10%;
  padding-right: 10rem; 
}
.nav-item {
  margin-left: 1.5rem;
}
</style>

